import {Component, OnInit} from '@angular/core';

import {BDUtilityService} from '@brother-apps/brother-dealerapp-shared-lib';
import {UserContextService} from '../../../../core/services/user-context.service';
import {ProjectsContactsWidgetService} from '../../services/projects-contacts-widget.service';
import {IContact} from '../../../contact-widget/interfaces/contact.interface';


@Component({
    selector: 'app-multi-contacts-widget',
    templateUrl: './multi-contacts-widget.component.html',
    styleUrls: ['./multi-contacts-widget.component.scss']
})
export class MultiContactsWidgetComponent implements OnInit {


    public isContactOpen = false;
    public extendedContacts: { contact: IContact, isRelatedContact: boolean }[] = null;
    public contact: IContact = null;


    constructor(
        private userContextService: UserContextService,
        private utilityService: BDUtilityService,
        private projectsContactsWidgetService: ProjectsContactsWidgetService
    ) {
    }

    ngOnInit() {
    }

    async openContactWidget(): Promise<void> {
        this.isContactOpen = !this.isContactOpen;
        if (this.isContactOpen) {
            this.extendedContacts = await this.projectsContactsWidgetService.getWidgetContactList();
        }
    }


    requestCallback(extendedContact: { contact: IContact, isRelatedContact: boolean }): string {
        return this.utilityService.requestCallback(
            extendedContact.contact.lastName,
            extendedContact.contact.firstName,
            extendedContact.contact.email,
            extendedContact.contact.brotherTitle,
            extendedContact.isRelatedContact ? this.userContextService.getRelatedContactEmail() : extendedContact.contact.email.toLocaleLowerCase()
        );
    }

}
